"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiButton = exports.isUiButton = void 0;
const router_1 = require("client/components/router");
const callable_1 = require("client/components/ui/callable");
const react_1 = require("react");
const React = require("react");
require("./button.less");
exports.isUiButton = (value) => value && value.type && value.type === UiButton;
class UiButton extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (event) => {
            if (this.props.link) {
                router_1.RouteManager.transitionTo(this.props.link);
            }
            else {
                callable_1.callable(this.props.onClick)(event);
            }
        };
    }
    render() {
        const { className = "", disabled, primary } = this.props;
        const primaryClass = primary ? "ui-button--primary" : "";
        return (React.createElement("button", { className: `ui-button ${primaryClass} ${className}`, disabled: disabled, type: this.props.type || "button", onClick: this.handleClick }, this.props.children));
    }
}
exports.UiButton = UiButton;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/button/button.tsx
// module id = 2122
// module chunks = 0 1 2